import React, { useState } from 'react';
import { Box } from 'rebass';
import { TextStyled } from '@nike/nike-design-system-components';
import { nike } from '@nike/nike-design-tokens';
import UnderlineNavigation from '../../../components/UnderlineNavigation';
import BulkDeleteProducts from './BulkDeleteProducts';
import FindProducts from './FindProducts';

const find = 'find';
const bulk = 'bulk';
const { podiumCdsColorTextPrimaryInverse } = nike;

const componentMap = {
  find: <FindProducts />,
  bulk: <BulkDeleteProducts />
};

const FindAndDeleteProductCodes = () => {
  const [key, setMapKey] = useState(find);

  return (
    <Box
      sx={{
        background: podiumCdsColorTextPrimaryInverse,
        padding: '10px 20px'
      }}
    >
      <TextStyled appearance='title3'>Find and Delete Product Codes</TextStyled>

      <Box mt='10px'>
        <UnderlineNavigation
          list={[
            {
              onClick: () => {
                setMapKey(find);
              },
              title: 'Find'
            },
            {
              onClick: () => {
                setMapKey(bulk);
              },
              title: 'Bulk Delete'
            }
          ]}
        />
      </Box>
      {componentMap[key]}
    </Box>
  );
};

export default FindAndDeleteProductCodes;
